(ns dashboard.components.paginated-list.events
  (:require [re-frame.core :as rf]))

(rf/reg-event-db
  ::set-page
  (fn [db [_ view-config-path page-number]]
    (assoc-in db (conj view-config-path :page) page-number)))

(rf/reg-event-db
  ::set-next-page
  (fn [db [_ view-config-path]]
    (update-in db (conj view-config-path :page) inc)))

(rf/reg-event-db
  ::set-prev-page
  (fn [db [_ view-config-path]]
    (update-in db (conj view-config-path :page) dec)))

(rf/reg-event-db
  ::set-pagesize
  (fn [db [_ view-config-path pagesize]]
    (-> db
        (assoc-in (conj view-config-path :pagesize) pagesize)
        ;; Jump to first page, since page size change affects paging
        (assoc-in (conj view-config-path :page) 1))))

;; Merge updates with the state under `view-config-path`
(rf/reg-event-fx
  ::update-state
  (fn [{:keys [db]} [_ {:keys [view-config-path updates]}]]
    {:db (update-in db
                    view-config-path
                    merge
                    updates)}))

(rf/reg-event-db
 ::toggle-column-popup
 (fn [db [_ view-config-path]]
   (update-in db (conj view-config-path :column-popup-visible?) not)))

(rf/reg-event-db
 ::set-column-visible
 (fn [db [_ view-config-path column-id visible?]]
   (assoc-in db (into view-config-path [:column-visibility column-id]) visible?)))

(rf/reg-event-db
 ::enable-editable-row
 (fn [db [_ view-config-path initial]]
   (assoc-in db (conj view-config-path :editable-row) initial)))

(rf/reg-event-db
  ::clear-search-query
  (fn [db [_ view-config-path]]
    (update-in db view-config-path dissoc :search-query :visible-search-query)))
